import { defineMessages } from 'react-intl';

export const messages = defineMessages({
  noFiles: {
    id: 'frontbucket.repository.diff.noFiles',
    description: 'Description of a diff section that has no modified files',
    defaultMessage: 'This {context} has no changed files to display.',
  },
  noFilesTitle: {
    id: 'frontbucket.repository.diff.noFilesTitle',
    description:
      'Title of a pull request diff section that has no modified files',
    defaultMessage: 'Nothing has changed',
  },
});
